export class Project {
  public companyId: number;
  public projectId: number;
  public projectCode: string;
  private _description: string;
  public review = 0;
  public lastCalculation: Date;
  public lastBackofficeImport: Date;

  get description(): string {
    return this._description;
  }

  set description(description :string) {
    this._description = this.ValidateLengthDescriptionProject(description);
  }

  getFormattedDate(value: Date, campo: string): string {
    let retono = '';
    if (!value) {
      if (campo === 'C') {
        retono = 'Nenhum cálculo realizado';
      }
      else {
        retono = 'Nenhuma importação realizada';
      }
    }
    else {
      const datahoraminuto: string[] = value.toLocaleString(navigator.language, { formatMatcher: 'basic' }).replace(' ', ' - ').split(':');
      retono = datahoraminuto[0] + ':' + datahoraminuto[1] + 'h';
    }
    return retono;
  }

  private ValidateLengthDescriptionProject(description: string) : string{

    if(description == undefined || description == '') {
      return '';
    }
    else if(description.length >= 200) {
      return description.slice(0, 160) + '...';
    }
    else {
      return description;
    }
  }

}
